import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase';
import { makeStyles, createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles'
import { CssBaseline, AppBar, Toolbar, Paper, Stepper, Step, StepLabel, Button, Typography, Divider } from '@material-ui/core';
import { red, grey} from '@material-ui/core/colors';
import AddressForm from '../components/AddressForm';
import PaymentForm from '../components/PaymentForm';
import Review from '../components/Review';

function Copyright() {
	return (
		<Typography variant="body2" color="textSecondary" align="center">
		{'Copyright © '}
		<Button component="a" target="_blank" rel="noopener noreferrer" color="inherit" href="https://www.team-power.com.mx/">
			Team Power
		</Button>{' '}
		{new Date().getFullYear()}
		{'.'}
		</Typography>
	);
}

const useStyles = makeStyles(theme => ({
	appBar: {
		position: 'relative',
	},
	layout: {
		width: 'auto',
		marginLeft: theme.spacing(2),
		marginRight: theme.spacing(2),
		[theme.breakpoints.up(800 + theme.spacing(2) * 2)]: {
		width: 800,
		marginLeft: 'auto',
		marginRight: 'auto',
		},
	},
	paper: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(3),
		padding: theme.spacing(2),
		[theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(3),
		padding: theme.spacing(3),
		},
	},
	stepper: {
		padding: theme.spacing(3, 0, 5),
	},
	buttons: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	button: {
		marginTop: theme.spacing(3),
		marginLeft: theme.spacing(1),
	},
}));
const theme = createMuiTheme({
	palette: {
		primary: { main: red[700] },
		secondary: { main: grey[800] }
	}
})

const steps = ['Formulario de Inscripción', 'Realizar Pago', 'Información de Órden'];

function getStepContent(step,props) {
	switch (step) {
		case 0:
			return <AddressForm {...props} />;
		case 1:
			return <PaymentForm />;
		case 2:
			return <Review {...props} />;
		default:
			throw new Error('Unknown step');
	}
}

export default function Transaction(props) {
    const id = props.match.params.id
	const classes = useStyles();
    const [activeStep, setActiveStep] = useState(2);
    const [transaction,setTransaction] = useState({});

    useEffect(() => {
        firestore.collection('transactions').doc(id).onSnapshot(snap => {
            setTransaction(snap.data())
        })
    },[id])

	return (
		<ThemeProvider theme={theme}>
			<CssBaseline />
			<AppBar position="absolute" color="default" className={classes.appBar}>
				<Toolbar>
					<picture style={{ padding: '.5rem' }}>
						<img style={{ height: '3.5rem' }} src="/images/logo.png" alt="Teampower Institute"/>
					</picture>
				</Toolbar>
			</AppBar>
			<main className={classes.layout}>
				<Paper className={classes.paper}>
				<Typography component="h1" variant="h4" align="center">
					Competencias y ALGO MÁS que hacen a un COACH PROFESIONAL
				</Typography>
				<Divider style={{ marginTop: '2rem' }} />
				<Stepper activeStep={activeStep} className={classes.stepper}>
					{steps.map(label => (
					<Step key={label}>
						<StepLabel>{label}</StepLabel>
					</Step>
					))}
				</Stepper>
				<React.Fragment>
					{activeStep === steps.length ? (
					<React.Fragment>
						<Typography variant="h5" gutterBottom>
						Thank you for your order.
						</Typography>
						<Typography variant="subtitle1">
						Your order number is #2001539. We have emailed your order confirmation, and will
						send you an update when your order has shipped.
						</Typography>
					</React.Fragment>
					) : (
					<React.Fragment>
						<Review data={transaction} />
					</React.Fragment>
					)}
				</React.Fragment>
				</Paper>
				<Copyright />
			</main>
		</ThemeProvider>
	)
}